export const OVERVIEW_TAB_INDEX = 0;
export const PROPERTIES_TAB_INDEX = 1;
